import { createFileRoute } from "@tanstack/react-router";
import TmsForAnxietyOcdPtsdPage from "@/pages/learn/TmsForAnxietyOcdPtsdPage";
import { page9 } from "@/pages/learn/learnDataP9";
export const Route = createFileRoute("/learn/tms-for-anxiety-ocd-ptsd")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "TMS for Anxiety, OCD, PTSD and Bipolar: FDA Status",
        },
        {
          name: "description",
          content:
            "Condition-by-condition guide to TMS for anxiety, OCD, PTSD, and bipolar depression: which uses are FDA-cleared, which are off-label or investigational, and why.",
        },
        {
          property: "og:title",
          content: "TMS for Anxiety, OCD, PTSD and Bipolar: FDA Status",
        },
        {
          property: "og:description",
          content:
            "Condition-by-condition guide to TMS for anxiety, OCD, PTSD, and bipolar depression: which uses are FDA-cleared, which are off-label or investigational, and why.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/learn/tms-for-anxiety-ocd-ptsd",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/learn/tms-for-anxiety-ocd-ptsd",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(page9.schemaJson),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <TmsForAnxietyOcdPtsdPage />;
}
